// Generated from SVG to Code Figma Plugin

export const ProductLineEmptyFolder = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.46484 4.49651C2.46484 3.944 2.91275 3.49609 3.46526 3.49609H8.53062C9.12443 3.49609 9.68756 3.75985 10.0677 4.21602L11.3689 5.77741C11.749 6.23359 12.3121 6.49734 12.9059 6.49734H20.4723C21.0249 6.49734 21.4728 6.94523 21.4728 7.49776V20.5032C21.4728 21.0557 21.0249 21.5036 20.4723 21.5036H3.46526C2.91275 21.5036 2.46484 21.0557 2.46484 20.5032V4.49651Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M8.96094 13.9995H14.9634"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
